
export * from '../../frontend-taglib-clay/__liferay__/exports/@clayui$pagination-bar.js';

import __default__ from '../../frontend-taglib-clay/__liferay__/exports/@clayui$pagination-bar.js';
export default __default__;
